import React, { useEffect, useState, useCallback }  from 'react';
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import './index.scss';

import SkeletonLoader from "../../../../../ui/SkeletonLoader";

import { useScanInfoContext } from "../../../../../../pages/ScanInfo/ScanInfoContext";

import { useSelector, useDispatch } from 'react-redux';
import { getDigitalFootPrint } from "../../../../../../store/actions/thirdPartyRiskAction";
import { formatNumber } from "../../../../../../utils/util";

const DigitalFootPrint = () =>{

    const digitalFootprintStatsResponse = useSelector((state) => state.thirdPartyRisk.digitalFootPrintStats);

    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
    } = useScanInfoContext();

    const dispatch = useDispatch();

    const [footprintLoading, setFootprintLoading] = useState(false);
    const [digitalFootprintStats, setDigitalFootprintStats] = useState(null)

    const fetchDigitalFootprint = useCallback(()=>{
        setFootprintLoading(true);
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`;
        dispatch(getDigitalFootPrint(params))
    },[organizationId, domainId, scanId, dispatch])

    useEffect(()=>{
        if (triggerStatsFetch) {
            fetchDigitalFootprint();
            setTriggerStatsFetch(false);
        }
    },[triggerStatsFetch, setTriggerStatsFetch, fetchDigitalFootprint])

    useEffect(()=>{        
        if(digitalFootprintStatsResponse !== null) {
            setFootprintLoading(false);
            setDigitalFootprintStats(digitalFootprintStatsResponse);
        }
    },[digitalFootprintStatsResponse])

    return (
        <>
            <div className="bg-white-with-shadow p-4 mt-3">
                {
                    footprintLoading ?
                    <SkeletonLoader type={"line"} count={7} currentPage={"digitalfootprint"} />
                    :
                    <motion.div
                        className="h-100"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4 }}
                    >
                        <div className="digital-footprint-container">
                            <p className="heading">Digital Footprint</p>
                            <Row>
                                <Col lg={6}>
                                    <div className="subdomain-details-container">
                                        <h4 className="subdomains-heading">Subdomains</h4>
                                        <div className="subdomain-count d-flex align-items-center gap-3">
                                            <p className="total-count">{formatNumber(digitalFootprintStats?.stats?.domain_digital_footprint?.subdomains?.total)}</p>
                                            <p className="domain-count new"><span>{formatNumber(digitalFootprintStats?.stats?.domain_digital_footprint?.subdomains?.new_record)}</span> New</p>
                                            <p className="domain-count existing"><span>{formatNumber(digitalFootprintStats?.stats?.domain_digital_footprint?.subdomains?.existing_record)}</span> Exisiting</p>
                                        </div>
                                        <div className="http-status-container d-flex align-items-center gap-2">
                                            <div className="footprint-status">
                                                <p className="footprint-heading">HTTP Inactive</p>
                                                <p className="footprint-count">{formatNumber(digitalFootprintStats?.stats?.domain_digital_footprint?.subdomains?.http_inactive)}</p>
                                            </div>
                                            <div className="footprint-status">
                                                <p className="footprint-heading">HTTPS Inactive</p>
                                                <p className="footprint-count">{formatNumber(digitalFootprintStats?.stats?.domain_digital_footprint?.subdomains?.https_inactive)}</p>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <div className="subdomain-details-container">
                                        <h4 className="subdomains-heading">IPs</h4>
                                        <div className="subdomain-count d-flex align-items-center gap-3">
                                            <p className="total-count">{formatNumber(digitalFootprintStats?.stats?.domain_digital_footprint?.ip_addresses?.total)}</p>
                                            <p className="domain-count new"><span>{formatNumber(digitalFootprintStats?.stats?.domain_digital_footprint?.ip_addresses?.new_record)}</span> New</p>
                                            <p className="domain-count existing"><span>{formatNumber(digitalFootprintStats?.stats?.domain_digital_footprint?.ip_addresses?.existing_record)}</span> Exisiting</p>
                                        </div>
                                        <div className="http-status-container d-flex align-items-center gap-2">
                                            <div className="footprint-status w-100">
                                                <p className="footprint-heading">Blacklisted IPs</p>
                                                <p className="footprint-count">{formatNumber(digitalFootprintStats?.stats?.domain_digital_footprint?.ip_addresses?.blacklisted)}</p>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <div className="footprint-content-list">
                                <Row>
                                    <Col lg={4}>
                                        <div className="footprint-status w-100 mb-3">
                                            <p className="footprint-heading">Git Leaks</p>
                                            <p className="footprint-count">{formatNumber(digitalFootprintStats?.stats?.domain_digital_footprint?.gitleaks?.total)}</p>
                                        </div>
                                    </Col>
                                    <Col lg={4}>
                                        <div className="footprint-status w-100">
                                            <p className="footprint-heading">SSL Certificates</p>
                                            <p className="footprint-count">{formatNumber(digitalFootprintStats?.stats?.domain_digital_footprint?.ssl_certificates?.total)}</p>
                                        </div>
                                    </Col>
                                    <Col lg={4}>
                                        <div className="footprint-status w-100">
                                            <p className="footprint-heading">Hosting Providers</p>
                                            <p className="footprint-count">{formatNumber(digitalFootprintStats?.stats?.domain_digital_footprint?.hosting_providers?.total)}</p>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={4}>
                                        <div className="footprint-status w-100">
                                            <p className="footprint-heading">Web Server</p>
                                            <p className="footprint-count">{formatNumber(digitalFootprintStats?.stats?.domain_digital_footprint?.webservers?.total)}</p>
                                        </div>
                                    </Col>
                                    <Col lg={4}>
                                        <div className="footprint-status w-100">
                                            <p className="footprint-heading">Technologies</p>
                                            <p className="footprint-count">{formatNumber(digitalFootprintStats?.stats?.domain_digital_footprint?.technologies?.total)}</p>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </motion.div> 
                }                   
            </div>
        </>
    )
}

export default DigitalFootPrint;